import * as React from 'react';
import { Platform, Switch, Text, TextInput, View, StyleSheet } from 'react-native';
import * as AppUtilities from "../context/AppUtilities";
import * as AppConstants from "../context/AppConstants";
import * as AppState from "../context/AppState";
import { AppContext } from "../context/AppContext";
import { Divider } from 'react-native-paper';
import { CustomScrollView } from '../components/CustomScrollView';
import { CustomButton } from '../components/CustomButton';
//import { TextInput } from 'react-native-paper';
import { useForm, Controller } from "react-hook-form";

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    padding: 20,
  },
  heading: {
    fontSize: 18,
    fontWeight: "bold",
  },
  label: {
    fontSize: 14,
    fontWeight: "bold",
    paddingBottom: 10,
  },
  labelPadLeft: {
    fontSize: 14,
    fontWeight: "bold",
    paddingLeft: 5,
  },
  normal: {
    fontSize: 14,
    paddingRight: 10,
    flexShrink: 1,
  },
  divider: {
    marginVertical: 15,
  },
  line: {
    paddingBottom: 15,
    flexWrap: "wrap",
  },
  listItemStyle: {
    paddingLeft: 5,
  },
  textInput: {
    width: "100%",
    marginVertical: 10,
    borderWidth: 1,
    padding: 10,
    borderColor: '#000000',
  },
  line: {
    paddingBottom: 15,
    flexWrap: "wrap",
    flexDirection: "row",
    alignItems: "center",
  },
  toggle: {
    marginVertical: 10,
    marginRight: 10,
  },
});

export function Subscribe({ navigation }) {
  const [subscribeExtra, setSubscribeExtra] = React.useState(true);
  const { showPermanentSnack, showTemporarySnack, hideSnack, getLoginState, showSpinner, hideSpinner } = React.useContext(AppContext);

  const { register, control, handleSubmit, setValue, reset, formState: { errors } } = useForm({
    defaultValues: {
      zip: "",
      email: "",
    }
  });

  async function onSubmit(data) {
    try {
      showSpinner();
      hideSnack();

      await AppUtilities.fetchUnauthorized(
        "Subscribe.onSubmit",
        "/find_humane/api/subscribe",
        "POST",
        {
          email: data.email,
          zip: data.zip,
          extra: subscribeExtra,
        }
      );

      showTemporarySnack("Successfully subscribed");

      reset();

      navigation.pop();

    } catch (e) {
      showPermanentSnack(AppUtilities.getErrors(e), "Retry", () => onSubmit(data));
      AppUtilities.handleException(e, "Subscribe.onSubmit");
    } finally {
      hideSpinner();
    }

  }

  async function onValidationErrors(errors) {
    showTemporarySnack("There are some errors in the form");
  }

  return (
    <CustomScrollView>
      <Text selectable={true} style={styles.normal}>Get an email when new products or locations are added near you:</Text>
      <Divider style={AppConstants.STYLES.marginVertical10} />

      <Controller
        control={control}
        name="zip"
        rules={{
          required: true,
        }}
        render={({ field: { onChange, onBlur, value } }) => (
          <TextInput
            placeholder="Zip code"
            placeholderTextColor="#777777"
            value={value}
            onChangeText={onChange}
            style={AppConstants.STYLES.width100PmarginVertical10border1}
            returnKeyType="next"
            onBlur={onBlur}
          />
        )}
      />
      {errors.zip && <Text selectable={true} style={AppConstants.STYLES.fontBoldColorRed}>Zip code is required.</Text>}

      <Controller
        control={control}
        name="email"
        rules={{
          required: true,
          pattern: {
            value: AppConstants.EMAIL_REGEX,
            message: "Invalid email",
          },
        }}
        render={({ field: { onChange, onBlur, value } }) => (
          <TextInput
            placeholder="Your email"
            placeholderTextColor="#777777"
            value={value}
            onChangeText={onChange}
            style={AppConstants.STYLES.width100PmarginVertical10border1}
            returnKeyType="send"
            onBlur={onBlur}
            autoComplete="email"
            keyboardType="email-address"
            textContentType="emailAddress"
            onSubmitEditing={handleSubmit(onSubmit, onValidationErrors)}
          />
        )}
      />
      {errors.email && <Text selectable={true} style={AppConstants.STYLES.fontBoldColorRed}>{errors.email.message ? errors.email.message : "Email is required"}</Text>}

      <View style={styles.line}>
        <Switch
          key="subscribeExtra"
          checked={subscribeExtra}
          style={styles.toggle}
          onValueChange={() => setSubscribeExtra(!subscribeExtra)}
          value={subscribeExtra}
        />
        <Text onPress={() => setSubscribeExtra(!subscribeExtra)}>Other news from Find Humane and animal welfare non-profits</Text>
      </View>

      <CustomButton
        onPress={handleSubmit(onSubmit, onValidationErrors)}
        style={AppConstants.STYLES.paddingVertical10}
      >Submit</CustomButton>

    </CustomScrollView>
  );
}
